import { AxiosResponse } from "axios";
import { IValidationResult } from "lobbie";
import { useCallback, useState } from "react";
import { useAxiosPoster } from "src/hooks/useAxios";
import { isValidPhoneNumber, removeNonDigits } from "src/utils";

export const useTwilioLandlineCheck = () => {
    const poster = useAxiosPoster();
    const [isNotLandline, setNotLandline] = useState<boolean | undefined>();
    const post = useCallback(
        (phone: string | undefined) => {
            if (!phone || !isValidPhoneNumber(phone)) return;

            poster("/shared/phone/verify", { phone: removeNonDigits(phone) })
                .then((response: AxiosResponse | void) => {
                    const result = response && (response.data as IValidationResult);
                    if (result) {
                        setNotLandline(result.success);
                    }
                })
                .catch(console.error);
        },
        [poster],
    );
    return {
        verify: post,
        isNotLandline,
    };
};
